module.exports = "<input\r\n  type=\"submit\"\r\n  class=\"button\"\r\n  (click)=\"clicked()\"\r\n  [value]=\"content\"\r\n  [disabled]=\"!valid\"\r\n  [class.cancel]=\"type === 'cancel'\"\r\n>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/ButtonComponent/button.component.html
// module id = ./src/app/common/components/ButtonComponent/button.component.html
// module chunks = main